import {
  ActionModal,
  ClockIcon,
  EllipsisVIcon,
  NoteFieldRow,
  PencilAltIcon,
  SingleInfoCard,
  Theme,
  TrashIcon,
  UserIcon,
  createStyles,
  makeStyles,
  useModal,
  useRouter,
} from '@forgeglobal/design-framework'
import { PopoverAction, PopoverListItem, PopoverListItemIcon, PopoverListItemText } from 'isolated-design-library'
import { Routes } from 'util/Routes'
import { useDeleteOfferingMutation, useGetAllOfferingsQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment, useState } from 'react'
import moment from 'moment'

const useStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    list: {
      margin: spacing(2, 0),
    },
  })
)

const CampaignSidebarCardList: React.FC<{ type: string }> = ({ type }) => {
  const classes = useStyles()
  const { data, refetch } = useGetAllOfferingsQuery()
  const [deleteOffering] = useDeleteOfferingMutation()
  const [campaignToBeDeleted, setCampaignToBeDeleted] = useState<string>()

  const campaigns = data?.allOfferings?.data ?? []
  const filteredCampaigns = campaigns.filter(campaign => campaign.status === type)

  const [showModal, hideModal] = useModal(() => {
    const deleteDraftOffering = () => {
      if (!campaignToBeDeleted) return
      deleteOffering({
        variables: {
          offeringId: campaignToBeDeleted,
        },
      })
      refetch()
      setCampaignToBeDeleted(undefined)
    }

    return (
      <ActionModal
        open
        hideModal={hideModal}
        title="Delete Draft Offering"
        cancelAction={hideModal}
        confirmAction={() => {
          deleteDraftOffering()
          hideModal()
        }}
        positiveMessage="Confirm"
        negativeMessage="Cancel"
        header="Are you sure?"
        actionMessage="Please confirm deletion of this offering."
      />
    )
  }, [campaignToBeDeleted])

  const ActionMenu: React.FC<{ campaignId: string }> = ({ campaignId }) => {
    const { history } = useRouter()

    const handleEditClick = () => history.push(Routes.campaignForm(campaignId))

    return (
      <Fragment>
        <PopoverListItem button onClick={handleEditClick}>
          <PopoverListItemIcon>
            <PencilAltIcon />
          </PopoverListItemIcon>
          <PopoverListItemText>Edit</PopoverListItemText>
        </PopoverListItem>
        <PopoverListItem
          button
          onClick={() => {
            setCampaignToBeDeleted(campaignId)
            showModal()
          }}>
          <PopoverListItemIcon>
            <TrashIcon />
          </PopoverListItemIcon>
          <PopoverListItemText>Delete</PopoverListItemText>
        </PopoverListItem>
      </Fragment>
    )
  }

  return (
    <div className={classes.list}>
      {filteredCampaigns.map(campaign => {
        const notes = type !== 'Draft' && (
          <Fragment>
            <NoteFieldRow icon={ClockIcon}>
              Scheduled for {moment(campaign.available_from).format('h:mm:ss a, MMMM Do, YYYY')}
            </NoteFieldRow>
            <NoteFieldRow icon={UserIcon}>{`${campaign.num_participants} recipients`}</NoteFieldRow>
          </Fragment>
        )

        return (
          <SingleInfoCard
            key={`${campaign.name}${campaign.company.name}`}
            link={Routes.campaignForm(campaign.id)}
            logo={campaign.company.logo_url}
            leftTitle={campaign.name !== '' ? campaign.name : 'Unnamed Campaign'}
            leftSubtitle="Offering"
            action={
              type === 'Draft' && (
                <PopoverAction icon={<EllipsisVIcon />} actionMenu={<ActionMenu campaignId={campaign.id} />} />
              )
            }
            notes={notes}
          />
        )
      })}
    </div>
  )
}

export { CampaignSidebarCardList }
